// initial state
import * as base from "./base.js";
const reverbName = "/admin/api/reverb";
const ReverbHelp = "/admin/api/ReverbHelp";

const obj = base.setBaseUrl("reverb", reverbName);
const obj1 = base.setBaseUrl("ReverbHelp", ReverbHelp);
const a = Object.assign(obj, obj1);
export default a;
